import $ from "jquery";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		const $footerToggle = $( '.footer__toggle' );

		function toggleFooter () {
			$( 'body' ).toggleClass( 'footer-open' ).removeClass( 'menu-open' );
		}

		function closeFooter() {
			$( 'body' ).removeClass( 'footer-open' );
		}

		// Toggle mobile menu.
		$footerToggle.on(
			'click touch',
			function ( e ) {
				toggleFooter();
			}
		);
	}
);
